<header>
  <app-header-cmp></app-header-cmp>
</header>
<div class="admin-layout">
  <div class="admin-panels">
    <div
      class="section-panel users-panel"
      [routerLink]="['/admin/users']"
      [ngClass]="{ active: selectedPanel === 'users' }"
    >
      <!-- <img [src]="constants.assetsPath + '/img/icons/users-grey.svg'"
         class="icon icon-default" />
    <img [src]="constants.assetsPath + '/img/icons/users-gold.svg'"
         class="icon icon-active" /> -->
      <span class="panel-title">
        <span>users</span>
      </span>
    </div>

    <div
      class="section-panel policies-panel"
      [routerLink]="['/admin/policies']"
      [ngClass]="{ active: selectedPanel === 'policies' }"
    >
      <!-- <img [src]="constants.assetsPath + '/img/icons/sliders-grey.svg'"
         class="icon icon-default" />
    <img [src]="constants.assetsPath + '/img/icons/sliders-gold.svg'"
         class="icon icon-active" /> -->
      <span class="panel-title">
        <span>policies</span>
      </span>
    </div>

    <div
      class="section-panel alerts-panel"
      [routerLink]="['/admin/alerts']"
      [ngClass]="{ active: selectedPanel === 'alerts' }"
    >
      <!-- <img [src]="constants.assetsPath + '/img/icons/palette-grey.svg'"
         class="icon icon-default" />
    <img [src]="constants.assetsPath + '/img/icons/palette-gold.svg'"
         class="icon icon-active" /> -->
      <span class="panel-title">
        <span>customise</span>
      </span>
    </div>

    <div
      class="section-panel alerts-panel"
      [routerLink]="['/admin/additionalExplanation']"
      [ngClass]="{ active: selectedPanel === 'additionalExplanation' }"
    >
      <!-- <img [src]="constants.assetsPath + '/img/icons/settings-grey.svg'"
         class="icon icon-default" />
    <img [src]="constants.assetsPath + '/img/icons/settings-gold.svg'"
         class="icon icon-active" /> -->
      <span class="panel-title">
        <span>additional explanation</span>
      </span>
    </div>

    <div
      class="section-panel alerts-panel"
      [routerLink]="['/admin/settings']"
      [ngClass]="{ active: selectedPanel === 'settings' }"
      *ngIf="hasAdminAccess"
    >
      <!--<img [src]="constants.assetsPath + '/img/icons/settings-grey.svg'"
           class="icon icon-default" />
      <img [src]="constants.assetsPath + '/img/icons/settings-gold.svg'"
           class="icon icon-active" />-->
      <span class="panel-title">
        <span>settings</span>
      </span>
    </div>

    <div
      class="section-panel alerts-panel"
      [routerLink]="['/admin/nexus']"
      [ngClass]="{ active: selectedPanel === 'nexus' }"
      *ngIf="hasAdminAccess"
    >
      <span class="panel-title">
        <span>nexus</span>
      </span>
    </div>

    <div
      class="section-panel alerts-panel"
      [routerLink]="['/admin/configuration']"
      [ngClass]="{ active: selectedPanel === 'configuration' }"
      *ngIf="isUserAdmin"
    >
      <!-- <img [src]="constants.assetsPath + '/img/icons/database-grey.svg'"
         class="icon icon-default" />
    <img [src]="constants.assetsPath + '/img/icons/database-gold.svg'"
         class="icon icon-active" /> -->
      <span class="panel-title">
        <span>configuration</span>
      </span>
    </div>

    <div
      class="section-panel alerts-panel"
      [routerLink]="['/admin/playground']"
      [ngClass]="{ active: selectedPanel === 'playground' }"
      *ngIf="isUserAdmin"
    >
      <!-- <img [src]="constants.assetsPath + '/img/icons/people-carry-grey.svg'"
         class="icon icon-default" />
    <img [src]="constants.assetsPath + '/img/icons/people-carry-gold.svg'"
         class="icon icon-active" /> -->
      <span class="panel-title">
        <span>playground</span>
      </span>
    </div>
  </div>
  <!-- <i class="fas fa-address-book"></i> -->
  <div class="panel-container">
    <router-outlet></router-outlet>
  </div>
</div>
